import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Instagram, Linkedin, MessageCircle, PlaySquare, Send, Star, Twitter, Users, Youtube } from 'lucide-react';
import logo from '../assets/logo.jpg';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const footerLinks = {
        product: [
            { name: 'Pricing', path: '/pricing' },
            { name: 'Products', path: '/products' },
            { name: 'Jarvis AI', path: '/jarvis' },
        ],
        company: [
            { name: 'About', path: '/about' },
            { name: 'Blog', path: '/blog' },
            { name: 'Contact', path: '/contact' },
        ],
        support: [
            { name: 'Help', path: '/support' },
            { name: 'FAQ', path: '/support' },
        ],
        legal: [
            { name: 'Privacy', path: '/privacy' },
            { name: 'Terms', path: '/terms' },
        ],
    };

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-top">
                    <div className="footer-brand">
                        <Link to="/" className="footer-logo">
                            <img src={logo} alt="NetHyTech" className="footer-logo-image" />
                            <span className="logo-text">NetHyTech</span>
                        </Link>
                        <p className="footer-tagline">
                            The Future of Technology, Inspired by Iron Man.
                        </p>
                        <div className="footer-social">
                            {[
                                { href: 'https://insta.openinapp.co/AnubhavChaturvedi-Insta', label: 'Instagram', Icon: Instagram },
                                { href: 'https://linkedin.openinapp.co/AnubhavChaturvedi-Linkedin', label: 'LinkedIn', Icon: Linkedin },
                                { href: 'https://x.com/NetHyTech', label: 'X (Twitter)', Icon: Twitter },
                                { href: 'https://www.youtube.com/@NetHyTech', label: 'YouTube', Icon: Youtube },
                                { href: 'https://github.com/AnubhavChaturvedi-GitHub', label: 'GitHub', Icon: Github },
                                { href: 'https://telegram.openinapp.co/Telegram-Nethytech', label: 'Telegram Channel', Icon: Send },
                                { href: 'https://telegram.openinapp.co/chatgroup-nethytech', label: 'Telegram Chat Group', Icon: Users },
                                { href: 'https://whatsapp.com/channel/0029VayODJX7tkjEthQmsn16', label: 'WhatsApp Channel', Icon: MessageCircle },
                                { href: 'https://yt.openinapp.co/NetHyTech-MemberShip', label: 'Channel Membership', Icon: Star },
                                { href: 'https://yt.openinapp.co/Membership-Videos', label: 'Membership Videos', Icon: PlaySquare }
                            ].map(({ href, label, Icon }) => (
                                <a
                                    key={label}
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="social-link"
                                    aria-label={label}
                                    title={label}
                                >
                                    <Icon size={17} />
                                </a>
                            ))}
                        </div>
                    </div>

                    <div className="footer-links-grid">
                        <div className="footer-links-column">
                            <h4>Product</h4>
                            <ul>
                                {footerLinks.product.map((link) => (
                                    <li key={link.name}><Link to={link.path}>{link.name}</Link></li>
                                ))}
                            </ul>
                        </div>
                        <div className="footer-links-column">
                            <h4>Company</h4>
                            <ul>
                                {footerLinks.company.map((link) => (
                                    <li key={link.name}><Link to={link.path}>{link.name}</Link></li>
                                ))}
                            </ul>
                        </div>
                        <div className="footer-links-column">
                            <h4>Support</h4>
                            <ul>
                                {footerLinks.support.map((link) => (
                                    <li key={link.name}><Link to={link.path}>{link.name}</Link></li>
                                ))}
                            </ul>
                        </div>
                        <div className="footer-links-column">
                            <h4>Legal</h4>
                            <ul>
                                {footerLinks.legal.map((link) => (
                                    <li key={link.name}><Link to={link.path}>{link.name}</Link></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>© {currentYear} NetHyTech. All rights reserved.</p>
                    <p className="footer-credit">Built by Anubhav Chaturvedi</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
